var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('b-link',{staticClass:"btn-show-plan",attrs:{"disabled":!!_vm.error},on:{"click":function($event){return _vm.goToRegister()}}},[_vm._v("Skip this "),_c('img',{staticClass:"icon",attrs:{"src":require('@/assets/icons/icons-chevron-right.svg')}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }